import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { languages } from "../../constant/Languages";
import services from "../../services/services";
import { STORAGE_PATH } from "../../constant/string";

const LanguageInputComponent = ({
  label,
  name,
  handlechange,
  handleBlur,
  editData,
  id,
  accept,
  choosenLanguage
}: any) => {
  const [files, setFiles] = useState<any>([]);
  const [fileLanguages, setFileLanguages] = useState<any>([]);
  // per-row upload progress: { [rowIndex]: 0–100 } while a file is uploading
  const [uploadProgress, setUploadProgress] = useState<{ [index: number]: number }>({});

  const handleChangeOnLanguageFile = async (e: any, index: number) => {
    if (e.target.accept === "audio/*") {
      try {
        setUploadProgress((prev) => ({ ...prev, [index]: 0 }));
        const res = await services.uploadAudio(e.target.files[0], (percent: number) => {
          setUploadProgress((prev) => ({ ...prev, [index]: percent }));
        });
        if (res?.data?.data?.url[0]?.path) {
          return res?.data?.data?.url[0]?.path;
        } else {
          console.error("Invalid response from the server");
          toast.error("Audio upload failed. Please try again.");
          return null; // or throw an error
        }
      } catch (error) {
        console.error("Error uploading audio:", error);
        toast.error("Audio upload failed. Please try again.");
        return null; // or throw an error
      } finally {
        setUploadProgress((prev) => {
          const next = { ...prev };
          delete next[index];
          return next;
        });
      }
    } else {
      console.error("Only use audio format");
      return null; // or throw an error
    }
  };

  const handleFileChange = async (index: number, event: any) => {
    const newFile: any = await handleChangeOnLanguageFile(event, index);

    if (newFile !== null) {
      // Always store the file at the ROW's index. The previous code appended when
      // the slot was undefined, so uploading e.g. French before Spanish landed the
      // French file in the Spanish row (files[] and fileLanguages[] are positional).
      setFiles((prev: any[]) => {
        const next = [...prev];
        while (next.length <= index) next.push("");
        next[index] = newFile;
        return next;
      });
    }
  };

  const removeHandler = async (index: any) => {
    const updatedFiles = [...files];
    const updatedLanguages = [...fileLanguages];
    const fileToDelete = updatedFiles[index];

    try {
      const audioUrl = fileToDelete;
      const res = await services.removeAudio(audioUrl);
      if (res?.status == 200) {
        console.log("Audio Removed Successfully");
      }
    } catch (error) {
      console.log("Error removing audio:", error);
    }

    updatedFiles[index] = "";
    // updatedLanguages.splice(index, 1);

    setFiles(updatedFiles);

    const combinedData = updatedFiles
      .map((file, i) => ({
        language: updatedLanguages[i],
        file: file,
      }))
      .filter((item) => item.file); // a row without a file is not an audio entry

    handlechange(combinedData);
  };

  useEffect(()=>{
    if(choosenLanguage && choosenLanguage.length > 0){
      for(let lang of choosenLanguage){
        if(!fileLanguages.includes(lang)){
          fileLanguages.push(lang)
        }
      } 
    }
      const removedIndex = fileLanguages.findIndex((element:any) => !choosenLanguage.includes(element));
      if(removedIndex != -1){
        files.splice(removedIndex, 1);
        fileLanguages.splice(removedIndex, 1)
      }
  },[choosenLanguage])

  useEffect(() => {
    let combinedData = [];
    combinedData = files
      .map((path: any, index: any) => {
        const language = fileLanguages[index];
        const file = (path || "").replace(`${STORAGE_PATH}/audioUpload/`, "");
        return { language, file };
      })
      // Empty slots (not yet uploaded / removed) must not be saved as language
      // entries: the app lists a stop's languages from this map and would show a
      // flag with no audio behind it.
      .filter((item: any) => item.language && item.file);
    handlechange(combinedData);
  }, [files, fileLanguages,choosenLanguage]);

  useEffect(() => {
    if (editData) {
      const parsed = JSON.parse(editData);
      const mappedFiles = parsed?.map((item: any) => item.file);
      const mappedLanguages = parsed?.map((item: any) => item.language);
      setFiles(mappedFiles);
      setFileLanguages(mappedLanguages);
    }
  }, [editData]);

  return (
    <div className="">
      <label className="block mb-2 mt-3 text-xl font-bold text-darkgray font-roboto items-start flex">
        {label}
      </label>
      <div className="bg-gray-50 border font-roboto font-normal text-black border-slate-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500 outline-none">
        <div>
          {fileLanguages.map((file: any, index: any) => (
            <div key={index} className="flex items-center mb-2">
              <span className="mr-2">{index + 1}.</span>
              <span className="px-2 py-1 bg-[#F0F0F0] border-1 m-1 font-roboto font-normal">
                {uploadProgress[index] !== undefined ? (
                  <span className="inline-block w-48 align-middle">
                    <span className="block text-xs font-roboto mb-1">
                      {uploadProgress[index] < 100
                        ? `Uploading… ${uploadProgress[index]}%`
                        : "Saving…"}
                    </span>
                    <span className="block h-2 w-full bg-gray-300 rounded">
                      <span
                        className="block h-2 bg-aqua rounded"
                        style={{ width: `${uploadProgress[index]}%` }}
                      ></span>
                    </span>
                  </span>
                ) : files[index]?files[index]: <label htmlFor={name} className="font-roboto font-normal">
            <span className="px-2 py-1 bg-lightaqua border-2 m-1 font-roboto font-normal cursor-pointer">
            choose File
          </span>
          <input
            className="font-roboto font-normal"
            accept={`${accept}/*`}
            id={id}
            name={name}
            onChange={(event)=>handleFileChange(index,event)}
            type="file"
            multiple
            onBlur={handleBlur}
            hidden
          />
             </label>}
              </span>
              <h2 className="bg-gray-50 border border-slate-300 text-gray-900 text-sm rounded-lg p-1 outline-none">
              {languages
              .filter(elm => elm.code === file)
              .map(filteredLang => (
              filteredLang.name
                ))}
              </h2>
               <button
                onClick={() => removeHandler(index)}
                type={"button"}
                className="ml-2 px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600 focus:outline-none"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageInputComponent;
